import React, { useEffect, useState } from 'react';
import './Dashboard.css'; // 스타일 시트를 임포트합니다.

const Dashboard = ({ bcuCode, systemYN }) => {
  const [ordersLeft, setOrdersLeft] = useState([]);  // 왼쪽 그리드 데이터
  const [ordersRight, setOrdersRight] = useState([]); // 오른쪽 그리드 데이터
  const [error, setError] = useState(''); // 오류 메시지 상태

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;


  // 주문 목록 조회 함수
  const fetchOrders = async (gu, bcuCode) => {
    try {
      // 오늘 날짜 계산
      const today = new Date();
      const fromDate = today.toISOString().split('T')[0]; // 'YYYY-MM-DD' 형식
      const toDate = today.toISOString().split('T')[0]; // 오늘 날짜

      // 공백인 경우 '%%'로 처리
      const params = {        
        bcuCode: bcuCode,
        fromDate: fromDate,
        toDate: toDate,
        orderCus: '%%',
        orderNum: '%%', // 공백으로 처리
        patientName: '%%', // 공백 처리
        gu,
      };

      // URL에 쿼리 파라미터 추가
      const url = new URL(`${serverUrl}/api/dashboard`);
      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      });

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('주문 목록 조회 실패');
      }
      const data = await response.json();
      return data;
    } catch (err) {
      setError('데이터를 불러오는 중 오류가 발생했습니다.');
      console.error(err);
    }
  };

  // 날짜 포맷을 yyyy-MM-dd로 변환하는 함수
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    // 왼쪽 그리드 데이터 (gu = 'Y')
    fetchOrders('Y', bcuCode).then((data) => {
      setOrdersLeft(data);
    });

    // 오른쪽 그리드 데이터 (gu = 'N')
    fetchOrders('N', bcuCode).then((data) => {
      setOrdersRight(data);
    });
  }, [bcuCode]); // bcuCode가 변경될 때마다 데이터 다시 요청

  return (
    <div className="dashboard-container">
      <h2 className="dashboard-h2">대시보드</h2>

      <div className="dashboard-layout">
        {/* 왼쪽 그리드 영역 */}
        <div className="dashboard-left">
          <h3 className="dashboard-h3">확정 주문</h3>
          <div className="dashboard-content">
            {error ? (
              <p>{error}</p>
            ) : (
              <table className="dashboard-orderlist-table">
                <thead>
                  <tr>
                  {systemYN === 'Y' && (
                    <th>거래처</th>
                  )}
                    <th>주문번호</th>
                    <th>순번</th>
                    <th>주문일</th>
                    <th>환자명</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersLeft.map((order, index) => (
                    <tr key={index}>
                      {systemYN === 'Y' && (
                        <td>{order.BCU_NAME}</td>
                      )}
                      <td>{order.SWM_CODE}</td>
                      <td>{order.SER}</td>
                      <td>{formatDate(order.ORDERDATE)}</td> {/* 주문일 형식 변환 */}
                      <td>{order.PATIENTNAME}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* 오른쪽 그리드 영역 */}
        <div className="dashboard-right">
          <h3 className="dashboard-h3">미확정 주문</h3>
          <div className="dashboard-content">
            {error ? (
              <p>{error}</p>
            ) : (
              <table className="dashboard-orderlist-table">
                <thead>
                  <tr>
                    {systemYN === 'Y' && (
                      <th>거래처</th>
                    )}
                    <th>주문번호</th>
                    <th>순번</th>
                    <th>주문일</th>
                    <th>환자명</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersRight.map((order, index) => (
                    <tr key={index}>
                      {systemYN === 'Y' && (
                        <td>{order.BCU_NAME}</td>
                      )}
                      <td>{order.SWM_CODE}</td>
                      <td>{order.SER}</td>
                      <td>{formatDate(order.ORDERDATE)}</td> {/* 주문일 형식 변환 */}
                      <td>{order.PATIENTNAME}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
